import { coerceBookingWireTotalPrice } from './bookingRecordMutate';

/** Israeli VAT rate applied at checkout (prices on assets are shown excluding VAT). */
export const BOOKING_VAT_RATE = 0.18;

/** Whole-number wire total including VAT, or null when subtotal is invalid. */
export function applyBookingVat(subtotal: unknown): number | null {
  const base = coerceBookingWireTotalPrice(subtotal);
  if (base === null) {
    return null;
  }
  return coerceBookingWireTotalPrice(base * (1 + BOOKING_VAT_RATE));
}

/** Ex-VAT booking subtotal for checkout — listed asset prices exclude VAT. */
export function resolveBookingCheckoutSubtotal(
  quickBookingLockedTotal: number | null,
  computedBookingTotalPrice: number | null,
  createBodyTotalPrice: unknown,
): number | null {
  const raw =
    quickBookingLockedTotal ??
    (typeof computedBookingTotalPrice === 'number' && Number.isFinite(computedBookingTotalPrice)
      ? computedBookingTotalPrice
      : null) ??
    (typeof createBodyTotalPrice === 'number' && Number.isFinite(createBodyTotalPrice)
      ? createBodyTotalPrice
      : null);
  return typeof raw === 'number' && raw > 0 ? raw : null;
}
